import { FC, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Arrow from './Arrow';

import styles from './Pagination.module.scss';
import Dropdown from './Dropdown';

interface IPaginationProps {
  count: number;
  currentPage: number;
  limit: number;
  remainder?: number;
  shoeMoreCount?: number;
  //eslint-disable-next-line
  updatePage: (page: number) => void;
  //eslint-disable-next-line
  updateLimit: (limit: number) => void;
  //eslint-disable-next-line
  showMore?: () => void;
}

const Pagination: FC<IPaginationProps> = ({
  count,
  currentPage,
  limit,
  remainder,
  updateLimit,
  updatePage,
  showMore,
  shoeMoreCount = 12,
}) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const pagesArray =
    count <= 5
      ? Array.from({ length: count }, (_, i) => i + 1)
      : currentPage - 2 <= 1
        ? [1, 2, 3, 4, 5, 0, count]
        : currentPage + 2 >= count
          ? [1, 0, count - 4, count - 3, count - 2, count - 1, count]
          : [1, 0, currentPage - 1, currentPage, currentPage + 1, 0, count];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node))
        setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.Pagination}>
      {remainder && remainder !== 0 ? (
        <div className={styles.show_more_holder}>
          <button
            className={styles.show_more}
            onClick={() => showMore && showMore()}
          >
            Показать еще {remainder > shoeMoreCount ? shoeMoreCount : remainder}{' '}
            из {remainder}
          </button>
        </div>
      ) : null}

      <div className={styles.pagination_holder}>
        <div className={styles.show_in_page}>
          <span>Показывать по</span>
          <div
            className={clsx(styles.select_holder, { [styles.open]: isOpen })}
            ref={modalRef}
          >
            <div
              className={styles.select}
              onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
            >
              <span>{limit}</span>
              <Dropdown />
            </div>
            <div className={styles.options}>
              <ul>
                {[20, 40, 60, 80, 100].map((number) => (
                  <li
                    key={number}
                    onClick={() => {
                      updateLimit(number);
                      setIsOpen(false);
                    }}
                  >
                    {number}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.holder}>
          <button
            onClick={() => updatePage(currentPage - 1)}
            disabled={currentPage === pagesArray[0]}
            className={styles.prev}
          >
            <Arrow />
          </button>
          <div className={styles.pages}>
            {pagesArray.map((item, key) => {
              if (item === 0)
                return (
                  <div
                    className={clsx(styles.item, {
                      [styles.active]: currentPage === item,
                    })}
                    key={key}
                  >
                    <span>...</span>
                  </div>
                );
              return (
                <div
                  className={clsx(styles.item, {
                    [styles.active]: currentPage === item,
                  })}
                  key={key}
                  onClick={() => {
                    updatePage(item);
                  }}
                >
                  <span>{item}</span>
                </div>
              );
            })}
          </div>
          <button
            onClick={() => updatePage(currentPage + 1)}
            disabled={currentPage === pagesArray[pagesArray.length - 1]}
            className={styles.next}
          >
            <Arrow />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
